// @ts-check
import React, { useState, useRef } from 'react';
import * as _ from 'lodash';

// utilities
import { USER_ROLES, STATUS_CODE } from '../../utilities/constants';

// service
import SessionStorageService from '../../services/utilities/SessionStorageService';
import DirectApiSettingsApi from '../../services/DirectApiSettings';

// components
import Auth from '../Auth';
import DirectRegisterOrganizationGuideModal from './DirectRegisterOrganizationGuideModal';
import { Unpublished } from '../icons/Unpublished';
import { ExternalServiceCooperationTermsOfServiceDialog } from '../modals/ExternalServiceCooperationTermsOfServiceDialog';

// modals
import { DirectCommunicationErrorModal } from './DirectCommunicationErrorModal';

export default function UnUseContents() {
  const [isShowTermsOfServiceDialog, setIsShowTermsOfServiceDialog] = useState(
    false
  );
  const [
    isShowRegisterOrganizationGuideModal,
    setIsShowRegisterOrganizationGuideModal,
  ] = useState(false);
  const isSending = useRef(false);
  const [isShowErrorModal, setIsShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const agreedTermsSubmit = async () => {
    if (isSending.current) {
      return;
    }
    isSending.current = true;
    try {
      const fieldId = SessionStorageService.getFieldId();
      const { data, result, status } = await DirectApiSettingsApi.agreed_terms(
        fieldId
      );
      setIsShowTermsOfServiceDialog(false);
      if (!result || status === STATUS_CODE.badRequest) {
        setErrorMessage(_.get(data, 'message', null));
        setIsShowErrorModal(true);
        return;
      }
      setIsShowRegisterOrganizationGuideModal(true);
    } catch (error) {
      setIsShowErrorModal(true);
    } finally {
      isSending.current = false;
    }
  };
  return (
    <React.Fragment>
      <Unpublished className='icon--2_4x ExternalServiceCooperation__contents-status-icon--not-cooperated' />
      <span className='ExternalServiceCooperation__contents-status ExternalServiceCooperation__contents-status--not-cooperated'>
        未連携
      </span>
      <Auth
        approvedRoles={[
          USER_ROLES.prime,
          USER_ROLES.branch,
          USER_ROLES.manager,
        ]}
      >
        <div className='ExternalServiceCooperation__contents-btn'>
          <button
            className='btn'
            onClick={() => setIsShowTermsOfServiceDialog(true)}
          >
            連携する
          </button>
        </div>
      </Auth>
      <ExternalServiceCooperationTermsOfServiceDialog
        visible={isShowTermsOfServiceDialog}
        onClose={() => {
          setIsShowTermsOfServiceDialog(false);
        }}
        onSubmit={agreedTermsSubmit}
      />
      <DirectRegisterOrganizationGuideModal
        visible={isShowRegisterOrganizationGuideModal}
        setVisible={setIsShowRegisterOrganizationGuideModal}
      />
      <DirectCommunicationErrorModal
        visible={isShowErrorModal}
        setVisible={setIsShowErrorModal}
        errorMessage={errorMessage}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectUnUseContents.jsx